// Shown when a newer build is deployed but auto-reload was blocked (loop
// guard). Ported from the reference games' ui/UpdateNotice.jsx.

import { retryManualUpdate } from "../native/checkAppUpdate.ts";
import { t, useT } from "../i18n.ts";

function formatBuildLabel(buildId?: string): string {
  if (!buildId || buildId === "dev") return t("devBuild");
  const plus = buildId.indexOf("+");
  if (plus === -1) return buildId;
  return `${buildId.slice(0, plus)} (${buildId.slice(plus + 1)})`;
}

export default function UpdateNotice({
  localId,
  remoteId,
}: {
  localId?: string;
  remoteId?: string;
}) {
  const tt = useT();
  return (
    <>
      <div className="modal-backdrop" />
      <div className="update-notice-wrap">
        <div
          className="update-notice"
          role="alertdialog"
          aria-labelledby="update-notice-title"
        >
          <h1 id="update-notice-title" className="update-notice-title">
            {tt("updateNeeded")}
          </h1>
          <p className="update-notice-sub">{tt("updateBodyWeb")}</p>
          <dl className="update-notice-versions">
            <div>
              <dt>{tt("currentVersion")}</dt>
              <dd>{formatBuildLabel(localId)}</dd>
            </div>
            <div>
              <dt>{tt("latestVersion")}</dt>
              <dd>{formatBuildLabel(remoteId)}</dd>
            </div>
          </dl>
          <div className="update-notice-actions">
            <button
              type="button"
              className="update-notice-btn primary"
              onClick={() => remoteId && void retryManualUpdate(remoteId)}
            >
              {tt("retryUpdate")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
